import { render, staticRenderFns } from "./dictionary-manage.vue?vue&type=template&id=3ea323fa&scoped=true&"
import script from "./dictionary-manage.vue?vue&type=script&lang=ts&"
export * from "./dictionary-manage.vue?vue&type=script&lang=ts&"
import style0 from "./dictionary-manage.vue?vue&type=style&index=0&id=3ea323fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea323fa",
  null
  
)

export default component.exports